import { render, staticRenderFns } from "./OperationsView.vue?vue&type=template&id=71836784&scoped=true&"
import script from "./OperationsView.vue?vue&type=script&lang=js&"
export * from "./OperationsView.vue?vue&type=script&lang=js&"
import style0 from "./OperationsView.vue?vue&type=style&index=0&id=71836784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71836784",
  null
  
)

export default component.exports